import { ChangeDetectionStrategy, Component, computed, inject, input, Renderer2, signal } from '@angular/core';
import { DOCUMENT, NgClass } from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {DrawerComponent, TooltipDirective} from "../../shared";
import { TailwindService } from '@seven1/angular-storyblok/tailwind';
import { IInfoButtonBlok } from './info-button.model';


@Component({
    selector: 'app-info-button',
    imports: [MatIconModule, DrawerComponent, TooltipDirective, NgClass],
    templateUrl: './info-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class]': 'getDisplayClasses()',
    },
})
export class InfoButtonComponent {
    private _tailwind = inject(TailwindService);
    private _renderer = inject(Renderer2);
    private _document = inject(DOCUMENT);

    block = input.required<IInfoButtonBlok>();

    drawerActive = signal<boolean>(false);

    getDisplayClasses = computed<string[]>(() => {
        return this._tailwind.getDisplayClasses(this.block());
    });

    getButtonAlignClasses = computed<string[]>(() => {
        const block = this.block();
        return [
            'block',
            ...this._tailwind.getSpacingClasses({
                marginX: block.align,
                marginXTablet: block.alignTablet,
                marginXDesktop: block.alignDesktop,
            }),
        ];
    });

    toggleOverlay(e: MouseEvent | TouchEvent | KeyboardEvent) {
        e.stopPropagation();
        this.drawerActive.set(!this.drawerActive());
        if (this.drawerActive()) {
            this._renderer.setStyle(this._document.body, 'overflow', 'hidden')
        } else {
            this._renderer.setStyle(this._document.body, 'overflow', 'auto');
        }
    }
}
